import React, { Component } from "react";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "components/CustomButtons/Button";

import NavPills from "components/NavPills/NavPills.jsx";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";
import { withStyles } from "@material-ui/core/styles";

import Port from "../../granular/MasterData/port";
import Vessellist from "../../granular/MasterData/vessellist";
import Layer from "../../granular/MasterData/layer";
import Office from "../../granular/MasterData/office";
import Vesselowner from "../../granular/MasterData/vesselowner";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { pushLoader } from "../../actions/main";
import { fetchCompany, fetchVessel } from "../../api/vesselowner";
import { fetchPOIPort } from "../../api/port";
import { fetchPOIOffice } from "../../api/office";
import { fetchLayers } from "../../api/portal";

const styles = theme => ({
  title: {
    textAlign: "center",
    flex: 1,
    fontSize: "32px",
    fontWeight: 500
  }
});

class Masterdata extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "pertamina",
      datatable: [],
      dataVessel: [],
      dataport: [],
      dataoffice: [],
      datalayer: []
    };
  }

  UNSAFE_componentWillMount() {}

  handleChangeTab = tab => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
    if (tab === "vessel") {
      this.getDataVessel();
    } else if (tab === "port") {
      this.getDataPort();
    } else if (tab === "office") {
      this.getDataOffice();
    } else if (tab === "layer") {
      this.getDataLayer();
    }
  };

  getDataVessel = async () => {
    this.props.pushLoader(true);
    this.setState({ loader: true });
    await fetchCompany()
      .then(response => {
        if (response != null) {
          this.setState({ datatable: response.data.results });
        }
        this.props.pushLoader(false);
        this.setState({ loader: false });
      })
      .catch(error => {
        this.setState({ loader: false });
        this.props.history.push("/pages/login#logout");
        //this.props.pushToken(error);
      });
    await fetchVessel()
      .then(response => {
        if (response != null) {
          this.setState({ dataVessel: response.data.results });
        }
        //this.props.pushLoader(false);
        this.setState({ loader: false });
      })
      .catch(error => {
        this.setState({ loader: false });
        this.props.history.push("/pages/login#logout");
        //this.props.pushToken(error);
      });
  };

  getDataPort = () => {
    this.props.pushLoader(true);
    this.setState({ loader: true });
    fetchPOIPort()
      .then(response => {
        if (response != null) {
          this.setState({ dataport: response.data.results });
        }
        this.props.pushLoader(false);
        this.setState({ loader: false });
      })
      .catch(error => {
        this.setState({ loader: false });
        this.props.history.push("/pages/login#logout");
        //this.props.pushToken(error);
      });
  };

  getDataOffice = () => {
    this.props.pushLoader(true);
    this.setState({ loader: true });
    fetchPOIOffice()
      .then(response => {
        if (response != null) {
          this.setState({ dataoffice: response.data.results });
        }
        this.props.pushLoader(false);
        this.setState({ loader: false });
      })
      .catch(error => {
        this.setState({ loader: false });
        this.props.history.push("/pages/login#logout");
        //this.props.pushToken(error);
      });
  };

  getDataLayer = () => {
    this.props.pushLoader(true);
    this.setState({ loader: true });
    fetchLayers()
      .then(response => {
        if (response != null) {
          this.setState({ datalayer: response.data.results });
        }
        this.props.pushLoader(false);
        this.setState({ loader: false });
      })
      .catch(error => {
        this.setState({ loader: false });
        this.props.history.push("/pages/login#logout");
        //this.props.pushToken(error);
      });
  };

  render() {
    const { classes } = this.props;
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ justifyContent: "center" }}>
            <Typography className={classes.title}>Master Data</Typography>
            <CustomLinearProgress
              variant="determinate"
              color="gray"
              value={0}
              style={{ width: "40%", display: "inline-block" }}
            />
            <CustomLinearProgress
              variant="determinate"
              color="info"
              value={100}
              style={{ width: "20%", display: "inline-block" }}
            />
            <CustomLinearProgress
              variant="determinate"
              color="gray"
              value={0}
              style={{ width: "40%", display: "inline-block" }}
            />
          </div>
        </GridItem>
        <Grid item xs={12}>
          <Grid container justify="center">
            <GridItem xs={12} sm={12} md={10}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "12px"
                }}
              >
                <Button
                  color="behance"
                  round={this.state.activeTab === "pertamina" ? true : false}
                  simple={this.state.activeTab === "pertamina" ? false : true}
                  disableRipple
                  onClick={() => this.handleChangeTab("pertamina")}
                  style={{
                    color:
                      this.state.activeTab === "pertamina" ? "white" : "black"
                  }}
                >
                  Pertamina Vessel
                </Button>
                <Button
                  color="behance"
                  round={this.state.activeTab === "vessel" ? true : false}
                  simple={this.state.activeTab === "vessel" ? false : true}
                  onClick={() => this.handleChangeTab("vessel")}
                  style={{
                    color: this.state.activeTab === "vessel" ? "white" : "black"
                  }}
                >
                  vessel owner
                </Button>
                <Button
                  color="behance"
                  round={this.state.activeTab === "port" ? true : false}
                  simple={this.state.activeTab === "port" ? false : true}
                  onClick={() => this.handleChangeTab("port")}
                  style={{
                    color: this.state.activeTab === "port" ? "white" : "black"
                  }}
                >
                  Port
                </Button>
                <Button
                  color="behance"
                  round={this.state.activeTab === "office" ? true : false}
                  simple={this.state.activeTab === "office" ? false : true}
                  onClick={() => this.handleChangeTab("office")}
                  style={{
                    color: this.state.activeTab === "office" ? "white" : "black"
                  }}
                >
                  Office
                </Button>
                <Button
                  color="behance"
                  round={this.state.activeTab === "layer" ? true : false}
                  simple={this.state.activeTab === "layer" ? false : true}
                  onClick={() => this.handleChangeTab("layer")}
                  style={{
                    color: this.state.activeTab === "layer" ? "white" : "black"
                  }}
                >
                  Layer
                </Button>
              </div>
              <div hidden={this.state.activeTab === "pertamina" ? false : true}>
                <Vessellist />
              </div>
              <div hidden={this.state.activeTab === "vessel" ? false : true}>
                <Vesselowner
                  datatable={this.state.datatable}
                  dataVessel={this.state.dataVessel}
                />
              </div>
              <div hidden={this.state.activeTab === "port" ? false : true}>
                <Port dataport={this.state.dataport} />
              </div>
              <div hidden={this.state.activeTab === "office" ? false : true}>
                <Office dataoffice={this.state.dataoffice} />
              </div>
              <div hidden={this.state.activeTab === "layer" ? false : true}>
                <Layer datalayer={this.state.datalayer} />
              </div>
              {/* <NavPills
                color="blue"
                alignCenter={true}
                tabs={[
                  {
                    tabButton: "Pertamina Vessel",
                    tabContent: (
                      <div>
                        <Vessellist />
                      </div>
                    )
                  },
                  {
                    tabButton: "Vessel Owner",
                    tabContent: (
                      <div>
                        <Vesselowner />
                      </div>
                    )
                  },
                  {
                    tabButton: "Port",
                    tabContent: (
                      <div>
                        <Port />
                      </div>
                    )
                  },
                  {
                    tabButton: "Office",
                    tabContent: (
                      <div>
                        <Office />
                      </div>
                    )
                  },
                  {
                    tabButton: "Layer",
                    tabContent: (
                      <div>
                        <Layer />
                      </div>
                    )
                  }
                ]}
              /> */}
            </GridItem>
          </Grid>
        </Grid>
      </GridContainer>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default withRouter(
  connect(
    mapStateToProps,
    {
      pushLoader
    }
  )(withStyles(styles)(Masterdata))
);
